module.exports = __webpack_public_path__ + "static/15_retro-storytelling.f834f1f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/15_retro-storytelling.jpg
// module id = 487
// module chunks = 110568472390859